import { useFile } from "../hooks/file.hooks";
import Document from "../components/Document";

type PreviewFileProps = {
	id: number;
};

const PreviewFile = ({ id }: PreviewFileProps) => {
	const { data: file } = useFile({ id });

	if (!file) {
		return null;
	}
	if (file.contentType.startsWith("image")) {
		return (
			<div>
				<img src={file.url} alt={file.url} className="max-h-[400px]" />
			</div>
		);
	}
	return (
		<Document
			file={{
				id: id,
				fileName: file.fileName,
			}}
		></Document>
	);
};

export default PreviewFile;
